
import importer from 'common/importer'
const Config = importer('Config')

class WebArticle {
  constructor(articles) {
    this.articles = articles
    this.sections = {
      aboutBiolife: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        49,
        43,
        42,
        86,
        129,
        138,
        139
      ],
      aboutPlasma: [9, 10, 11, 12],
      becomeDonor: [
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        32
      ],
      currentDonor: [22, 23, 24, 25, 26, 27]
    }
    this.regSymbolFilter = /[\/\\#,+()$~%.'":*?<>{}]/g
    this.regSpaceFilter = /\s/g
  }

  get parsedArticles() {
    return {
      aboutBiolife: this.buildWebSections('aboutBiolife'),
      aboutPlasma: this.buildWebSections('aboutPlasma'),
      becomeDonor: this.buildWebSections('becomeDonor'),
      currentDonor: this.buildWebSections('currentDonor'),
      completeArticles: this.articles
    }
  }

  buildWebSections(sectionName) {
    const sectionNames = this.sections[sectionName]
    return this.articles
      .filter(art => sectionNames.includes(art.content_id__c))
      .map(item => {
        const [section, title] = String(item.title__c).split(' - ')
        const name = title?.length > 0 ? title.trim() : section.trim()
        return {
          ...item,
          nameDb: item.name,
          name,
          webName: item.web_name__c
        }
      })
  }

  buildWebName(title) {
    return String(title)
      .toLowerCase() // ALL TO LOWER CASE
      .replace(this.regSpaceFilter, '-') // REPLACE SPACES WITH DASHES
      .replace(this.regSymbolFilter, '') // REMOVE SPECIAL CHARACTERS EXCEPT FOR DASHES
  }
}

const webArticlesParser = articles => {
  const webArticle = new WebArticle(articles)
  return webArticle.parsedArticles
}

const webArticles = {
  ABOUT_BIOLIFE_WHATS_NEW: 2,
  ABOUT_BIOLIFE_CONTACT_US: 8,
  ABOUT_PLASMA_VIDEO_GALLERY: 10,
  CURRENT_DONOR_TESTIMONIALS: 22,
  CURRENT_DONOR_YOUR_STORY: 25,
  WEB_DISCLAIMER_TEXT: 30,
  AGREE_RECEIVE_INFORMATION: 31,
  MOBILE_ELIGIBILITY_REQUIREMENTS: 32,
  MOBILE_AGREE_PHONE_NUMBER: 33,
  EMAIL_CONFIRMATION: 36,
  WEB_HOME_PLASMA_DONATION: 37,
  WEB_HOME_DEBIT_CARD: 38,
  WEB_HOME_NUTRITION_TIPS: 39,
  WEB_LOCATIONS_HERO_LEFT: 40,
  WEB_LOCATIONS_HERO_RIGHT: 41,
  MOBILE_PRIVACY: 42,
  ACCESSIBILITY_STATEMENT : 86,
  MOBILE_TERMS_CONDITIONS_OF_USE: 43,
  GIFT_CARD_PROFIT_SHARE_TERMS: 138,
  GIFT_CARD_EQUAL_VALUE_TERMS: 139,
  WHAT_TO_EXPECT: 44,
  MOBILE_WELCOME: 45,
  MOBILE_AGREE_PROVIDE_INFORMATION: 46,
  MOBILE_SMS_STATEMENT: 47,
  MOBILE_MARKETING_STATEMENT: 48,
  MOBILE_CONTACT_US_CONTENT: 58,
  NON_DISCRIMINATION: 49,
  MOBILE_TERMS_OF_USE: 63,
  WEB_HOME_HERO_CONTENT: 59,
  WEB_NEWS_HORIZONTAL1: 60,
  WEB_NEWS_HORIZONTAL2: 61,
  WEB_NEWS_VERTICAL: 62,
  REGISTRATION_HERO_TEXT: 67,
  PRODUCTION_TEXT: 87,
  HOME_FIND_YOUR_CENTER: 122,
  OPT_OUT_VERBIAGE: 124,
  PRODUCTION_TEXT_CONTACT_US: 125,
  REGISTRATION_TESTIMONIAL: 126,
  LOYALTY_ENROLMENT: 136,
  LOYALTY_ENROLMENT_SUCCESS: 137,
  LOYALTY_FAQS: 128,
  BIOLIFE_MOBILE_APP: 129,
  BIOLIFE_MOBILE_APP_VERBIAGE_1: 131,
  BIOLIFE_MOBILE_APP_VERBIAGE_2: 132,
  BIOLIFE_MOBILE_APP_VERBIAGE_3: 133,
  BIOLIFE_MOBILE_APP_VERBIAGE_4: 134,
  BIOLIFE_MOBILE_APP_VERBIAGE_5: 135,
  REDEEM_SUBTEXT :141,
  REDEEM_GIFTCARD_SUBTEXT:142,
  REDEEM_CHARITABLE_DONATION_SUBTEXT:143,
  REDEEM_DEBITCARD_SUBTEXT:144,
  REDEEM_REWARDS_ERROR_MSG: 145,
  REDEEM_REWARDS_SUCCES_MSG: 146,
  IMMERSIVE_DONOR_VIRTUAL_TOUR :148,
  STEP_BY_STEP_GUIDE: 15,
  SIGNUP_PAGE_HEADING :152,
  CREATE_PROFILE_PAGE_HEADING:153,
  STEP3_REGISTRATIONPAGE_TITLE: 154,
  FEEDBACK_TEXT_CONTACT_US: 155,
  POST_EMAIL_VERIFICATION_CONTENT: 156,
  BECOME_DONOR_BOTTOM_SECTION: 147,
  DONOR_ELIGIBILITY: 13,
  BUDDY_BONUS: 157,
  CONTACT_US_FAQS: 158
}

const BASE_WEB_URL = Config.WEB_APP_URL

export default { webArticlesParser, webArticles, BASE_WEB_URL }
